/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocioConfiguracion } from '../../conexiones';
import { IFiltrosTiposBodegas } from './entidades/filtrosTiposBodegas';
import ITiposBodegas from './entidades/tiposBodegas';

export default class ModeloTiposBodegas {
    public consultarTiposBodegas() {
        return manejadorRest<IRespuesta<ITiposBodegas>>(() => negocioConfiguracion.get('TipoBodega/ConsultarListaTipoBodega'), true);
    }
    public crearTiposBodegas(tiposBodegas: ITiposBodegas) {
        return manejadorRest<IRespuesta<ITiposBodegas>>(
            () => negocioConfiguracion.post('TipoBodega/GuardarTipoBodega', tiposBodegas),
            true
        );
    }
    public editarTiposBodegas(tiposBodegas: ITiposBodegas) {
        return manejadorRest<IRespuesta<ITiposBodegas>>(
            () => negocioConfiguracion.put('TipoBodega/EditarTipoBodega', tiposBodegas),
            true
        );
    }
    public eliminarTiposBodegas(tiposBodegas: ITiposBodegas) {
        return manejadorRest<IRespuesta<ITiposBodegas>>(
            () => negocioConfiguracion.delete('TipoBodega/EliminarTipoBodega', tiposBodegas),
            true
        );
    }
    public consultarTiposBodegasPorFiltro(filtrosTiposBodegas: Partial<ITiposBodegas>) {
        return manejadorRest<IRespuesta<ITiposBodegas>>(
            () => negocioConfiguracion.post('TipoBodega/ConsultarTipoBodegaPorFiltro', filtrosTiposBodegas),
            true
        );
    }
}
